import React from "react";

function Icon({ className = null, seasonColor, id = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="280"
      viewBox="0 0 200 280"
      preserveAspectRatio="none"
      className={className}
    >
      <defs>
        <clipPath id={`${id}-clip-path-5`}>
          <path
            fill="#fff"
            d="M0 0H200V280H0z"
            data-name="Rectangle 1796"
            transform="translate(-9236 -11193)"
          ></path>
        </clipPath>
      </defs>
      <g
        clipPath={`url(#${id}-clip-path-5)`}
        data-name="Groupe de masques 62"
        transform="translate(9236 11193)"
      >
        <g data-name="Groupe 11591" transform="translate(-9389.73 -11346.891)">
          <path
            fill={seasonColor}
            d="M0 135.582v17.9C84.64 153.48 154.191 86.137 162.168 0 68.73 16.191 0 70.758 0 135.582"
            data-name="Tracé 2665"
            transform="rotate(-20.97 719.053 60.778)"
          ></path>
          <path
            fill="#996b59"
            d="M0 135.582v17.9C84.64 153.48 154.191 86.137 162.168 0 68.73 16.191 0 70.758 0 135.582"
            data-name="Tracé 2666"
            transform="rotate(135 213.407 151.97)"
          ></path>
          <path
            fill="#165227"
            d="M0 219.584v28.987C137.079 248.571 249.721 139.5 262.641 0 111.312 26.222 0 114.6 0 219.584"
            data-name="Tracé 2667"
            transform="matrix(0 -1 1 0 0 499.255)"
          ></path>
          <path
            fill="#afc620"
            d="M0 28.987V0c137.08 0 249.722 109.066 262.641 248.57C111.312 222.349 0 133.974 0 28.987"
            data-name="Tracé 2668"
            transform="rotate(-90 373.913 125.342)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
